/*
  CUSTOM CODE: ADDED - aggiunte rapide dentro il carrello.
  Un solo ascoltatore sul documento, cosi' funziona anche sui pezzi di carrello
  che il tema ridisegna dopo un aggiornamento di quantita', e anche dentro
  l'anteprima che si apre a destra.

  23/09: il freno di sicurezza dello sticker pack adesso si ricorda quante
  correzioni ha gia' fatto anche dopo un ricaricamento della pagina. Prima il
  contatore ripartiva da zero a ogni reload: se lo stato non si sistemava (per
  esempio il pack finito, o lo sconto che non si applica) la pagina carrello si
  ricaricava all'infinito, ed e' il "brutto scherzo" che si vedeva.
*/
(function () {
  if (window.__customCartUpsell) return;
  window.__customCartUpsell = true;

  var BUSY = 'is-busy';
  var nativeFetch = window.fetch.bind(window);

  function cartUrl(path) {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  /*
    CUSTOM CODE: ADDED - dentro l'anteprima non si ricarica la pagina.
    Se il clic e' partito dal cassetto, chiediamo a Shopify di rimandarci anche
    i pezzi di pagina che il cassetto sa ridisegnare da solo: cosi' il pannello
    resta aperto e si aggiorna sul posto. Se qualcosa non torna, si ricarica la
    pagina come prima: meglio un lampo che un carrello sbagliato.
  */
  function drawerOf(node) {
    return node && node.closest ? node.closest('cart-drawer') : null;
  }

  function sectionsOf(drawer) {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return null;
    try {
      var list = drawer.getSectionsToRender() || [];
      var names = list
        .map(function (s) {
          return s.section || s.id;
        })
        .filter(Boolean);
      return names.length ? names : null;
    } catch (e) {
      return null;
    }
  }

  function repaint(drawer, data) {
    if (!drawer || !data || !data.sections) return false;
    if (typeof drawer.renderContents !== 'function') return false;
    try {
      drawer.renderContents(data);
      return true;
    } catch (e) {
      return false;
    }
  }

  function post(path, payload, drawer) {
    var names = sectionsOf(drawer);
    if (names) {
      payload.sections = names;
      payload.sections_url = window.location.pathname;
    }

    return nativeFetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });
  }

  function addToCart(id, quantity, properties, drawer) {
    var item = { id: id, quantity: quantity || 1 };
    if (properties) item.properties = properties;
    return post('cart/add.js', { items: [item] }, drawer);
  }

  // dopo un'aggiunta: nel cassetto ridisegniamo sul posto, nella pagina
  // carrello ricarichiamo. Il totale, gli sconti automatici e il blocco dello
  // sticker dipendono tutti dal contenuto del carrello ed e' piu' solido
  // rileggerli dal server che rifarli a mano.
  function afterAdd(drawer, data) {
    if (repaint(drawer, data)) {
      refreshCount();
      stickerSchedule();
      return;
    }
    window.location.reload();
  }

  /*
    CUSTOM CODE: ADDED - il legame fra cornice e manifesto.
    La cornice entra nel carrello portandosi dietro l'id della variante del
    manifesto a cui appartiene. Da li' in poi il carrello sa a chi accostarla e
    la disegna dentro il suo "set".
  */
  function pairingOf(button) {
    var box = button.closest('[data-frame-upsell]');
    if (!box) return null;

    var key = box.getAttribute('data-for-key');
    if (!key) return null;

    var props = { _set: key };
    var title = box.getAttribute('data-for-title');
    if (title) props._per = title;
    return props;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-goal-add], [data-upsell-add]');
    if (!button || button.disabled) return;

    var id = button.getAttribute('data-variant-id');
    if (!id) return;

    event.preventDefault();
    button.disabled = true;
    button.classList.add(BUSY);

    var drawer = drawerOf(button);
    var isGoal = button.hasAttribute('data-cart-goal-add');
    var isFree = button.hasAttribute('data-cart-goal-free');

    addToCart(id, 1, pairingOf(button), drawer)
      .then(function (data) {
        if (!isGoal) return data;
        // il cliente ha rimesso lo sticker pack a mano: non e' piu' "rifiutato".
        return post(
          'cart/update.js',
          { attributes: { _sticker_no: '', _sticker_auto: isFree ? '1' : '' } },
          drawer
        );
      })
      .then(function (data) {
        afterAdd(drawer, data);
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove(BUSY);
        button.setAttribute('data-error', 'true');
      });
  });

  /*
    CUSTOM CODE: ADDED - "+ Aggiungi" di "Completa la parete" (e della griglia
    delle cartoline) aggiunge e basta.
  */
  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('[data-quick-variant]');
      if (!trigger) return;

      var id = trigger.getAttribute('data-quick-variant');
      if (!id) return;
      if (trigger.disabled) return;

      event.preventDefault();
      event.stopPropagation();

      trigger.disabled = true;
      trigger.classList.add(BUSY);

      var drawer = drawerOf(trigger);

      addToCart(id, 1, null, drawer)
        .then(function (data) {
          afterAdd(drawer, data);
        })
        .catch(function () {
          trigger.disabled = false;
          trigger.classList.remove(BUSY);
          trigger.setAttribute('data-error', 'true');
        });
    },
    true
  );

  /*
    CUSTOM CODE: ADDED - lo sticker pack in regalo entra da solo.
    Lo stato lo scrive custom__cart-sticker-goal.liquid (data-sticker-state).
  */
  var CART_CHANGE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  var stickerBusy = false;
  var stickerAgain = false;
  var stickerTimer = null;
  var STICKER_CAP = 6;

  // freno di sicurezza che sopravvive ai ricaricamenti: senza, la pagina
  // carrello poteva entrare in un giro di reload che non finiva piu'.
  function applies(add) {
    var n = 0;
    try {
      n = parseInt(sessionStorage.getItem('smStickerFix') || '0', 10) || 0;
      if (add) sessionStorage.setItem('smStickerFix', String(n + 1));
    } catch (e) {
      n = window.__smStickerFix || 0;
      if (add) window.__smStickerFix = n + 1;
    }
    return n;
  }

  function drawerSectionId() {
    var el = document.querySelector('cart-drawer .cart-drawer[id]');
    return el ? el.id : null;
  }

  function readStickerState() {
    var sid = drawerSectionId();
    if (!sid) return Promise.resolve(null);
    return nativeFetch(cartUrl('?sections=' + encodeURIComponent(sid)), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        var html = (json && json[sid]) || '';
        var match = html.match(/<script[^>]*data-sticker-state[^>]*>([\s\S]*?)<\/script>/);
        return match ? JSON.parse(match[1]) : null;
      })
      .catch(function () {
        return null;
      });
  }

  function stickerNeeds(s) {
    if (!s || !s.variant) return false;
    if (s.reached && !s.hasPack) return s.auto || (!s.declined && s.available);
    if (!s.reached && s.hasPack && s.auto) return true;
    return false;
  }

  function stickerApply(payload) {
    applies(true);
    var drawer = document.querySelector('cart-drawer');
    return post('cart/update.js', payload, drawer).then(function (data) {
      if (onCartPage()) {
        window.location.reload();
        return;
      }
      repaint(drawer, data);
      refreshCount();
    });
  }

  // il numerino sull'icona del carrello in alto
  function refreshCount() {
    nativeFetch(cartUrl('cart.js'))
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document
          .querySelectorAll('.cart-count-badge, .cart-drawer__title-counter')
          .forEach(function (el) {
            el.textContent = cart.item_count;
          });
      })
      .catch(function () {});
  }

  function stickerCheck() {
    if (stickerBusy) {
      stickerAgain = true;
      return;
    }
    if (applies(false) >= STICKER_CAP) return;
    stickerBusy = true;

    readStickerState()
      .then(function (s) {
        if (!stickerNeeds(s)) return;
        var updates = {};

        if (s.reached && !s.hasPack) {
          if (s.auto) {
            return stickerApply({
              attributes: { _sticker_auto: '', _sticker_no: String(s.posters || 2) }
            });
          }
          updates[s.variant] = 1;
          return stickerApply({
            updates: updates,
            attributes: { _sticker_auto: '1', _sticker_no: '' }
          });
        }

        updates[s.variant] = 0;
        return stickerApply({ updates: updates, attributes: { _sticker_auto: '' } });
      })
      .catch(function () {})
      .then(function () {
        stickerBusy = false;
        if (stickerAgain) {
          stickerAgain = false;
          stickerSchedule();
        }
      });
  }

  function stickerSchedule() {
    clearTimeout(stickerTimer);
    stickerTimer = setTimeout(stickerCheck, 300);
  }

  // controllo veloce sullo stato gia' scritto in pagina
  function stickerInline() {
    var need = false;
    document.querySelectorAll('script[data-sticker-state]').forEach(function (el) {
      try {
        if (stickerNeeds(JSON.parse(el.textContent))) need = true;
      } catch (e) {}
    });
    if (need) stickerSchedule();
  }

  // 1) ogni richiesta al carrello fatta dalla pagina (tema compreso) passa di qui
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch(input, init);
    if (CART_CHANGE.test(url)) {
      request.then(stickerSchedule, function () {});
    }
    return request;
  };

  // 2) qualunque strada ridisegni il carrello porta con se' uno stato nuovo
  var inlineTimer = null;
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('script[data-sticker-state]')) ||
            (node.querySelector && node.querySelector('script[data-sticker-state]'))
          ) {
            clearTimeout(inlineTimer);
            inlineTimer = setTimeout(stickerInline, 150);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // 3) all'apertura di qualunque pagina
  stickerInline();

  /*
    CUSTOM CODE: ADDED - "Scegli la seconda" nel banner delle cartoline porta
    alla griglia qui sotto.
  */
  document.addEventListener('click', function (event) {
    var jump = event.target.closest('[data-pc-jump]');
    if (!jump) return;
    var goal = jump.closest('[data-pc-goal]');
    var grid = goal && goal.querySelector('[data-pc-next]');
    if (!grid) return;
    event.preventDefault();
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // "+N colori": apre i colori restanti sul posto, senza lasciare il carrello
  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-frame-more]');
    if (!more) return;
    event.preventDefault();
    var box = more.closest('[data-frame-upsell]');
    if (!box) return;
    box.querySelectorAll('[data-frame-extra]').forEach(function (el) {
      el.hidden = false;
    });
    more.remove();
  });

  // scelta del colore della cornice
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-frame-colour]');
    if (!swatch) return;
    event.preventDefault();
    var box = swatch.closest('[data-frame-upsell]');
    if (!box) return;
    box.querySelectorAll('[data-frame-colour]').forEach(function (el) {
      el.setAttribute('aria-pressed', 'false');
    });
    swatch.setAttribute('aria-pressed', 'true');

    var label = box.querySelector('[data-frame-pick]');
    if (label) label.textContent = swatch.getAttribute('data-colour-name') || '';

    var add = box.querySelector('[data-upsell-add]');
    if (add) add.setAttribute('data-variant-id', swatch.getAttribute('data-variant-id'));
  });
})();